<template>
  <div class="component-filter-switch">
    <div class="inner-wrap">
      <div class="content">
        <el-switch
          active-color="#13ce66"
          v-model="option.data"
          @input="changeOptionEvent"
          :active-value="1"
          :inactive-value="0"
        />
      </div>
      <div class="footer">
        <vxe-button @click="resetEvent" size="mini">{{ $t("button.clear") }}</vxe-button>
        <vxe-button status="primary" @click="confirmEvent" size="mini">{{ $t("button.confirm") }}</vxe-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterSwitch',
  props: {
    params: Object,
    renderOpts: Object
  },
  data () {
    return {
      column: null,
      option: null
    }
  },
  created () {
    this.load()
    if(this.renderOpts.selectedOptions) {
      this.option.data = this.renderOpts.selectedOptions;
    }
    this.$forceUpdate();
  },
  methods: {
    load () {
      const { column } = this.params
      const option = column.filters[0]
      this.column = column
      this.option = option
    },
    changeOptionEvent () {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data
      console.log("changed: ",this.option.data);
      $panel.changeOption(null, checked, option)
    },
    keyupEvent ({ $event }) {
      const { params } = this
      const { $panel } = params
      if ($event.keyCode === 13) {
        $panel.confirmFilter()
      }
    },
    confirmEvent () {
      const { $panel } = this.params
      console.log("switch: ",this.option);
      $panel.confirmFilter()
    },
    resetEvent () {
      const { $panel } = this.params
      $panel.resetFilter()
    }
  }
}
</script>

<style lang="scss">
.component-filter-switch {
  padding: 10px;
  .content{
    display: flex;
    justify-content: center;
    padding: 5px 0;
  }
  .footer{
    margin-top: 5px;
  }
}
</style>